import * as Converter from "./converter";

import type * as Type from "./type";
import type * as Repository from "../../_repository";

type Props = {
	viewModel: Type.ViewModel;
	optionPmsGetAvailableOptionListQueryData: Repository.Query.QueryData.OptionPmsGetAvailableOptionList.OptionPmsGetAvailableOptionListQueryData;
};

export const useViewData = ({
	viewModel: { optionID, subOptionID },
	optionPmsGetAvailableOptionListQueryData,
}: Props) => {
	const { viewData } = Converter.useViewDataConverter({
		optionPmsGetAvailableOptionListQueryData,
		selectedOptionID: optionID.value,
		selectedSubOptionID: subOptionID?.value,
	});

	return {
		viewData,
	};
};
